import React from 'react'
import '../calendar.css'
import { ClockIcon } from '@heroicons/react/20/solid'
import {parse} from 'date-fns'
import InternalCalendarMenu from '../InternalCalendarMenu/InternalCalendarMenu'
import SmallMonthViewCalendar from './SmallMonthViewCalendar/SmallMonthViewCalendar'
import LargeMonthViewCalendar from './LargeMonthViewCalendar/LargeMonthViewCalendar'

const MonthViewCalendar = (props) => {
  let firstDayOfCurrentMonth = parse(props.currentMonth, 'MMMM yyyy', new Date())

  return (
    <div className='mx-1 my-4 h-[750px] min-w-[1000px] border-solid border-b border-t-0 border-l-0 border-r-0 rounded-b-lg border-gray-200'>
        <div className="lg:flex lg:h-full md:h-full sm:h-full h-3 rounded-xl overflow-y-scroll lg:flex-col w-full ml-0">
        <InternalCalendarMenu view={'Month view'} setView={props.setView} selectedDay={props.selectedDay} setSelectedDay={props.setSelectedDay} calendarDaysWithEvents={props.calendarDaysWithEvents} firstDayOfCurrentMonth={firstDayOfCurrentMonth} setCurrentMonth={props.setCurrentMonth} currentMonth={props.currentMonth} />
          <div className='mt-4'>
            <div className="shadow ring-1 ring-black ring-opacity-5 rounded-t-2xl min-w-[700px] overflow-hidden lg:flex lg:flex-auto lg:flex-col">
              <div className="grid grid-cols-7 gap-px border-b border-gray-300 bg-gray-300 text-center text-xs font-semibold leading-6 text-gray-600 lg:flex-none">
                <div className="bg-gray-50 border border-gray-300 border-solid border-r-0 border-t-0 border-b-0 py-1">S<span className="sr-only sm:not-sr-only">un</span></div>
                <div className="bg-gray-50 py-1">M<span className="sr-only sm:not-sr-only">on</span></div>
                <div className="bg-gray-50 py-1">T<span className="sr-only sm:not-sr-only">ue</span></div>
                <div className="bg-gray-50 py-1">W<span className="sr-only sm:not-sr-only">ed</span></div>
                <div className="bg-gray-50 py-1">T<span className="sr-only sm:not-sr-only">hu</span></div>
                <div className="bg-gray-50 py-1">F<span className="sr-only sm:not-sr-only">ri</span></div>
                <div className="bg-gray-50 py-1 border border-gray-300 border-solid border-l-0 border-t-0 border-b-0">S<span className="sr-only sm:not-sr-only">at</span></div>
              </div>
              <div className="flex bg-gray-300 text-xs leading-6 border-solid border border-gray-300 text-gray-700 lg:flex-auto">
                <LargeMonthViewCalendar dayObject={props.dayObject} firstDayOfCurrentMonth={firstDayOfCurrentMonth} setEditEvent={props.setEditEvent} setEventToEdit={props.setEventToEdit} setSelectedDay={props.setSelectedDay} setView={props.setView} createNewCalendarEvent={props.createNewCalendarEvent} />
                <SmallMonthViewCalendar selectedDay={props.selectedDay} dayObject={props.dayObject} firstDayOfCurrentMonth={firstDayOfCurrentMonth} />
              </div>
          </div>
          {props.selectedDay?.events.length > 0 && (
            <div className="py-10 px-4 sm:px-6 lg:hidden">
              <ol className="divide-y divide-gray-100 overflow-hidden rounded-lg bg-white text-sm shadow ring-1 ring-black ring-opacity-5">
                {props.selectedDay.events.map((event) => (
                  <li key={event.id} className="group flex p-4 pr-6 focus-within:bg-gray-50 hover:bg-gray-50">
                    <div className="flex-auto">
                      <p className="font-semibold text-gray-900">{event.name}</p>
                      <time dateTime={event.datetime} className="mt-2 flex items-center text-gray-700">
                        <ClockIcon className="mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                        {event.time}
                      </time>
                    </div>
                    <a href={event.href} className="ml-6 flex-none self-center rounded-md border border-gray-300 bg-white py-2 px-3 font-semibold text-gray-700 opacity-0 shadow-sm hover:bg-gray-50 focus:opacity-100 group-hover:opacity-100">
                      Edit<span className="sr-only">, {event.name}</span>
                    </a>
                  </li>
                ))}
              </ol>
            </div>
          )}
        </div>
        </div>
    </div>
  )
}

export default MonthViewCalendar;